import { render, staticRenderFns } from "./help-action-card.vue?vue&type=template&id=21e6391a&scoped=true"
import script from "./help-action-card.vue?vue&type=script&lang=js"
export * from "./help-action-card.vue?vue&type=script&lang=js"
import style0 from "./help-action-card.vue?vue&type=style&index=0&id=21e6391a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e6391a",
  null
  
)

export default component.exports